<template>
    <v-dialog v-model="visible" max-width="600" persistent>
        <v-card :prepend-icon="alertIcon">
            <v-card-title>{{ dialogTitle }}</v-card-title>
            <v-card-text>
                <div v-for="(line, index) in dialogText.split('\n')" :key="index">{{ line }}</div>
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn color="text" dark @click="closeDialog">OK</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'AlertDialog',
    data() {
        return {
            visible: false,
            dialogTitle: '',
            dialogText: '',
            alertIcon: '',
            resolver: null
        };
    },
    methods: {
        showDialog(title, text, icon) {
            this.dialogTitle = title;
            this.dialogText = text;
            this.alertIcon = icon;
            this.visible = true;
            return new Promise((resolve) => {
                this.resolver = resolve;
            });
        },
        closeDialog() {
            this.visible = false;
            if (this.resolver) {
                this.resolver();
                this.resolver = null;
            }
        }
    },
};
</script>